import { AlertTriangle, RefreshCw, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  onGoHome?: () => void;
  showDetails?: boolean;
  details?: string;
}

export function ErrorState({
  title = "Ops! Algo deu errado",
  message,
  onRetry,
  onGoHome,
  showDetails = false,
  details
}: ErrorStateProps) {
  return (
    <Card className="border-destructive/50">
      <CardContent className="pt-6 text-center">
        <div className="mx-auto w-12 h-12 bg-destructive/10 rounded-full flex items-center justify-center mb-4">
          <AlertTriangle className="h-6 w-6 text-destructive" />
        </div>
        
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-muted-foreground mb-4 max-w-sm mx-auto">{message}</p>
        
        {showDetails && details && (
          <details className="mb-4 text-left max-w-md mx-auto">
            <summary className="cursor-pointer text-sm text-muted-foreground hover:text-foreground">
              Detalhes técnicos
            </summary>
            <pre className="mt-2 text-xs bg-muted p-3 rounded overflow-auto max-h-32">
              {details}
            </pre>
          </details>
        )}
        
        <div className="flex gap-2 justify-center">
          {onRetry && (
            <Button onClick={onRetry}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Tentar Novamente
            </Button>
          )}
          {onGoHome && (
            <Button variant="outline" onClick={onGoHome}>
              <Home className="mr-2 h-4 w-4" />
              Voltar ao Início
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
